<app-alert-box-component (OnButtonClick)="onAlertButtonClick($event)" (OnAlertClose)="closeAlert($event)"
    (OnAlertVisibility)="alertVisibility($event)" [bShowSecondButton]="bShowSecondAlertButton"
    [alertHeaderText]="alertHeaderText" [alertBodyText]="alertBodyText" [closeButtonText]="alertCloseButtonText"
    [secondButtonText]="alertSecondButtonText" [data]="alertBoxData" [bAlert]="bAlert"></app-alert-box-component>
<div>
    <div expand="lg" class="border-bottom border-bottom-3 border-bottom-primary ">
        <div>
            <form cForm [formGroup]="invitationForm" (ngSubmit)="submit()">

                <div class="row margin-bottom-10">
                    <div class="col-md-2"> <label cLabel for="tag">QR Delivery Channel</label></div>
                    <div class="col-md-4">
                        <div class="table-view">
                            
                            <select cSelect class="multiple" formControlName="isSingleDetailedInvitation">
                                <option value="">Select QR Delivery Channel</option> 
                                <option value="email">Email</option>
                                <!-- <option value="sms">SMS</option>                 -->
                                <option value="qrCode">Print</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-1"> <label cLabel for="tag">Invitation Status</label></div>
                    <div class="col-md-2">
                        <div class="table-view">
                            <select cSelect class="multiple" formControlName="ddlInvitationStatus">
                               
                                <option value="0">ALL</option>
                                <option value="1">Used</option>
                                <option value="2">Unused</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-2"><button class="btn btn-primary">Search</button></div>
                </div>
            </form>
        </div>
    </div>

    <c-smart-table id="invitationDownload" [columnSorter]="true" [columns]="columns" [columnFilter]="true"
        [itemsPerPageSelect]="true" [itemsPerPage]="15" [items]="serviceData" [tableBodyProps]="{ align: 'middle' }"
        [tableProps]="{ hover: true, striped: true, responsive: true }" (rowClick)="rowSelected($event)" clickableRows
        header pagination>
        <ng-template cTemplateId="tableData" let-columnName="columnName" let-item="item" let-tdContent="tdContent">
            <td>
                
                <ng-container [ngSwitch]="columnName">
                    <ng-container *ngSwitchCase="'isUsed'">
                        <c-badge [color]="getRoleBadge(item)">
                            {{(getRole(item))}}
                          </c-badge>
                          </ng-container>
                    <ng-container *ngSwitchCase="'img'">
                        <c-badge>
                            <img [src]="item.img" width="70" height="70"/>
                        </c-badge>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        {{tdContent}}
                    </ng-container>
                </ng-container>
            </td>
        </ng-template>
    </c-smart-table>
</div>